export const useWebView = () => {
  return {
    isWebView: window.location.pathname.startsWith('/wv/'),
    exitWebViewCancel: () =>
      window.location.assign('acorns://exit?navigate_to=back'),
  }
}
